import { render, staticRenderFns } from "./SpilkaFormioMF.vue?vue&type=template&id=205ded61&scoped=true"
import script from "./SpilkaFormioMF.vue?vue&type=script&lang=js"
export * from "./SpilkaFormioMF.vue?vue&type=script&lang=js"
import style0 from "./SpilkaFormioMF.vue?vue&type=style&index=0&id=205ded61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205ded61",
  null
  
)

export default component.exports